import React from 'react'
import cx from 'classnames'

import styles from './Separator.module.scss'

export const Separator = ({ className = undefined, maxWidth, tagName }) => {
  const Element = tagName ?? 'hr'

  return (
    <Element
      className={cx(styles.separator, { [className]: Boolean(className) })}
      style={{ maxWidth }}
    />
  )
}
